var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "patternmaker-patternmaker-view-thumbnails",
      "elementType": "section"
    }
  }, [_vm.enableSwiper ? _c('CustomContainer', {
    attrs: {
      "customClass": "patternmaker-patternmaker-view-thumbnails-wrapper",
      "elementType": "div"
    }
  }, [_c('swiper', {
    ref: "swiper",
    class: ['patternmaker-patternmaker-view-thumbnails-wrapper-swiper', {
      'patternmaker-patternmaker-view-thumbnails-wrapper-swiper--no-loop': !_vm.swiperOptions.loop
    }],
    attrs: {
      "auto-update": false,
      "cleanup-styles-on-destroy": true,
      "options": _vm.swiperOptions
    },
    on: {
      "touchEnd": _vm.swatchTouched
    }
  }, _vm._l(_vm.swatches, function (item, index) {
    return _c('swiper-slide', {
      key: index,
      class: ['patternmaker-patternmaker-view-item', {
        active: item.id === _vm.currentSwatch,
        disabled: !_vm.enabled
      }],
      attrs: {
        "data-swatch-id": item.id
      }
    }, [_c('CustomContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.id === _vm.currentSwatch,
        expression: "item.id === currentSwatch"
      }],
      attrs: {
        "elementType": "div",
        "customClass": "icon-check"
      }
    }), item.thumb ? _c('CustomImage', {
      attrs: {
        "customClass": "background",
        "src": item.thumb,
        "alt": item.display_name.default,
        "data-swatch-id": item.id
      }
    }) : _vm._e(), item.color ? _c('CustomContainer', {
      style: "background-color: ".concat(item.color),
      attrs: {
        "elementType": "div",
        "customClass": "background",
        "data-swatch-id": item.id
      }
    }) : _vm._e()], 1);
  }), 1), _c('CustomContainer', {
    attrs: {
      "customClass": ['patternmaker-patternmaker-view-thumbnails-wrapper-nav-wrapper', {
        'hide': !_vm.enableCarouselNavigation
      }],
      "elementType": "div"
    }
  }, [_c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-previous swatches",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-indicator-open patternMaker-arrow",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })]), _c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-next swatches",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right-indicator-open patternMaker-arrow",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })])])], 1) : _c('base-spinner', {
    ref: "spinner",
    attrs: {
      "size": "50",
      "position": "inherit"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }